import { render, staticRenderFns } from "./demandDetail.vue?vue&type=template&id=4588410a&scoped=true&"
import script from "./demandDetail.vue?vue&type=script&lang=js&"
export * from "./demandDetail.vue?vue&type=script&lang=js&"
import style0 from "./demandDetail.vue?vue&type=style&index=0&id=4588410a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4588410a",
  null
  
)

export default component.exports